/* v44: desktop header dropdown hardening (Mighty Dink)
   - 280ms close delay on pointerleave; stays open while pointer is over trigger or panel
   - gap bridge (CSS in md-v44-menu.css)
   - click/tap on a parent link toggles its dropdown
   - keyboard: focusing a parent link opens it; focus leaving closes; Escape closes */
(function () {
  var CLOSE_DELAY = 280, AIM_WINDOW = 260, lastY = null, lastDownAt = 0, px = 0, py = 0;
  // "menu aim": remember when the pointer was last travelling downward (towards the open dropdown panel)
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
    px = e.clientX; py = e.clientY;
    if (lastY !== null && e.clientY - lastY > 0.5) lastDownAt = performance.now();
    lastY = e.clientY;
  }, { passive: true, capture: true });
  function aiming() { return performance.now() - lastDownAt < AIM_WINDOW; }
  function inHeader() { var h = document.querySelector('header-menu'); h = h && h.closest('header, .header'); if (!h) return false; var r = h.getBoundingClientRect(); return py >= r.top && py <= r.bottom + 40; }
  function init() {
    var Ctor = customElements.get('header-menu');
    if (!Ctor || Ctor.prototype.__mdV44) return;
    var proto = Ctor.prototype, orig = proto.deactivate;
    proto.__mdV44 = true;
    function expanded(li) { var d = li && li.querySelector(':scope > .menu-list__trigger .menu-list__disclosure, :scope > .menu-list__link[aria-expanded]'); return !!d && d.getAttribute('aria-expanded') === 'true'; }
    proto.deactivate = function (ev) {
      var li = ev && ev.currentTarget instanceof Element ? ev.currentTarget : (ev && ev.target instanceof Element ? ev.target.closest('.menu-list__list-item') : null);
      if (ev && ev.type === 'pointerleave' && li && li.querySelector(':scope > .menu-list__submenu')) {
        var self = this;
        clearTimeout(li.__mdT);
        li.__mdT = setTimeout(function tick() {
          if (!li.matches(':hover') && expanded(li) && aiming() && inHeader()) { li.__mdT = setTimeout(tick, 120); return; }
          li.__mdT = null;
          if (li.matches(':hover') || li.matches(':focus-within')) return; // pointer came back to trigger/panel
          if (!expanded(li)) return; // another item took over in the meantime
          orig.call(self, ev);
        }, CLOSE_DELAY);
        return;
      }
      return orig.call(this, ev);
    };
    document.querySelectorAll('header-menu').forEach(wire);
  }
  function wire(menu) {
    if (menu.__mdWired) return; menu.__mdWired = true;
    // hover intent when switching between parents: crossing a neighbour on the way down to the panel must not steal the open menu
    var SWITCH_DELAY = 200, origActivate = menu.activate, swT = null;
    if (typeof origActivate === 'function') {
      menu.activate = function (ev) {
        var li = ev && ev.target instanceof Element ? ev.target.closest('.menu-list__list-item') : null;
        var openLi = menu.querySelector('.menu-list__list-item:has(> .menu-list__trigger .menu-list__disclosure[aria-expanded="true"])');
        clearTimeout(swT); swT = null;
        if (ev && ev.type === 'pointerenter' && !menu.__mdDirect && li && openLi && openLi !== li && matchMedia('(hover:hover)').matches) {
          swT = setTimeout(function tick() {
            if (!li.matches(':hover')) { swT = null; return; }
            if (aiming()) { swT = setTimeout(tick, 100); return; } // still heading down to the open panel
            swT = null; origActivate(ev);
          }, SWITCH_DELAY);
          return;
        }
        return origActivate(ev);
      };
    }
    menu.addEventListener('pointerover', function (e) {
      var li = e.target.closest && e.target.closest('.menu-list__list-item');
      if (li && li.__mdT) { clearTimeout(li.__mdT); li.__mdT = null; }
    });
    // click / tap toggles parent items
    menu.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.menu-list__trigger > a.menu-list__link');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      var li = a.closest('.menu-list__list-item'), btn = li && li.querySelector('.menu-list__disclosure');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-expanded') === 'true') btn.click();
      else { menu.__mdDirect = true; li.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false })); menu.__mdDirect = false; }
    }, true);
    // keyboard: open on focus of a parent link
    menu.addEventListener('focusin', function (e) {
      var a = e.target.closest && e.target.closest('.menu-list__trigger > a.menu-list__link');
      if (!a || !a.matches(':focus-visible')) return;
      var li = a.closest('.menu-list__list-item');
      var btn = li && li.querySelector('.menu-list__disclosure');
      if (btn && btn.getAttribute('aria-expanded') !== 'true') { menu.__mdDirect = true; li.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false })); menu.__mdDirect = false; }
    });
  }
  // Escape closes from anywhere (pointer-opened menus too)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('header-menu .menu-list__disclosure[aria-expanded="true"]').forEach(function (b) { b.click(); });
  });
  if (window.customElements) customElements.whenDefined('header-menu').then(init);
})();
